
export { useGlobal } from "/home/runner/work/hultafors-web/hultafors-web/libs/hultaforsgroup/hooks/src/lib/use-global/use-global.ts"